<template>
  <div>
    <p class="cm-mg-p-wzd text-left text-muted">
      1.1 {{ $t('sowing.sowing_method_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4 col-lg-4 col-xl-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          :placeholder="`${$t('common_words.code_enter')}...`"
          @click="handleClickOnCode('sowing.sowing_methods')"
        >
        </fg-input>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-5">
        <fg-input
          :label="`${$t('common_words.name')}: *`"
          type="text"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.name_enter')}...`"
        ></fg-input>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label for="">{{ $t('sowing.sowing_method') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary mb-3 shadow-sm required-type"
            v-model="model.type"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in sowingMethods"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-6">
        <div class="form-group has-label">
          <label>{{ $t('sowing.sowing_type') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary mb-3 shadow-sm required-sowing"
            v-model="model.sowing_type"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in sowingTypes"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-6 col-lg-6 col-xl-6">
        <div class="form-group has-label">
          <label>{{ $t('sowing.seed_type') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary mb-3 shadow-sm required-seed"
            v-model="model.seed_type_id"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in seedTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12">
        <select-businesses-component
          class="required-business"
          ref="select-businesses"
          :showLoading="false"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import Businesses from 'src/components/Selects/Businesses.vue';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [Businesses.name]: Businesses,
  },

  data() {
    return {
      model: {
        code: null,
        name: null,
        type: null,
        sowing_type: null,
        seed_type_id: null,
        businesses_id: [],
        businesses_names: [],
      },
      seedTypes: [],
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
        seed_type_id: {
          required: true,
        },
        sowing_type: {
          required: true,
        },
        type: {
          required: true,
        },
      },
    };
  },
  computed: {
    sowingTypes() {
      return [
        { id: 'siembra al voleo', value: i18n.t('sowing.broadcast_sowing') },
        { id: 'siembra en hoyos', value: i18n.t('sowing.drilling_sowing') },
        {
          id: 'siembra de Precision',
          value: i18n.t('sowing.precision_sowing'),
        },
        {
          id: 'siembra a tresbolillos',
          value: i18n.t('sowing.zig_zag_sowing'),
        },
        {
          id: 'siembra en almacigos',
          value: i18n.t('sowing.transplanting_sowing'),
        },
      ];
    },
    sowingMethods() {
      return [
        { id: 'directa', value: i18n.t('sowing.direct') },
        { id: 'indirecta', value: i18n.t('sowing.indirect') },
      ];
    },
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },

    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });
      return others;
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', {
            ...this.model,
            seedTypeName: this.model.seed_type_id
              ? this.seedTypes.find(
                  (seed) => seed.id === this.model.seed_type_id
                ).name
              : null,
          });

          return res;
        })
        .then((resp) => {
          if (!resp) return resp;
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else if (!isset(this.model.sowing_type)) {
            return this.validationInputsRequired('sowing');
          } else if (!isset(this.model.seed_type_id)) {
            return this.validationInputsRequired('seed');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            return true;
          }
        });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('seeding/seedtypes/field')])
        .then((response) => {
          const [response_seedtype] = response;
          this.seedTypes = response_seedtype.data.data;
          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model = { ...editForm };
            this.model.businesses_id = editForm.businesses.map(
              (business) => business.id
            );
          }
          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
